module.exports = __webpack_public_path__ + "img/fbt-iocn09.c9b56bb6.svg";